import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const API_BASE = import.meta.env.VITE_API_URL || "https://www.thehexaplay.com/api";

const BookingStatus = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkStatus = async () => {
      const merchantOrderId = searchParams.get("merchantOrderId");
      const bookingId = searchParams.get("bookingId");

      if (!merchantOrderId) {
        setError("Missing Order ID");
        setLoading(false);
        return;
      }

      try {
        // Call your backend status API
        const res = await axios.get(`${API_BASE}/payment/status/${merchantOrderId}`);
        const data = res.data;
        const state = (data.state || "").toUpperCase();

        // Prepare common data to pass to next page
        const statusPayload = {
          bookingId,
          merchantOrderId,
          statusData: data,
          amountPaise: data.amount,
        };

        setLoading(false);

        if (state === "COMPLETED") {
          localStorage.setItem(
            "hexaplay_payment_confirmation",
            JSON.stringify({
              paymentSuccess: true,
              merchantOrderId,
              bookingId,
              at: new Date().toISOString(),
            })
          );

          navigate("/booking-success", { state: statusPayload });
        } else if (state === "FAILED") {
          navigate("/payment-failed", { state: { ...statusPayload, message: data.errorContext?.description || "Payment Failed" } });
        } else {
          // If PENDING, wait a few seconds and retry (Simple Polling)
          setTimeout(() => checkStatus(), 3000);
        }
      } catch (err) {
        console.error(err);
        setError("Could not verify payment status.");
        setLoading(false);
        // Fallback to failed page after delay
        setTimeout(() => navigate("/payment-failed", { state: { message: "Verification Timeout" } }), 3000);
      }
    };

    checkStatus();
  }, [navigate, searchParams]);

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", flexDirection: "column" }}>
      <div className="spinner" style={{ border: "4px solid #f3f3f3", borderTop: "4px solid #3498db", borderRadius: "50%", width: "50px", height: "50px", animation: "spin 1s linear infinite" }}></div>
      <h2 style={{ marginTop: "20px" }}>Verifying Payment...</h2>
      <p>Please do not close this window.</p>
      {error && <p style={{ color: "red" }}>{error}</p>}
      
      <style>{`
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

export default BookingStatus;